export default __webpack_public_path__ + "static/media/NewBackgroundImage.8185e296.jpg";